"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _get = _interopRequireDefault(require("lodash/get"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _getFormMethods2 = _interopRequireDefault(require("../Form/getFormMethods"));

var _Checkbox = require("./Checkbox.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Checkbox = function Checkbox(_ref) {
  var checked = _ref.checked,
      className = _ref.className,
      disabled = _ref.disabled,
      error = _ref.error,
      id = _ref.id,
      label = _ref.label,
      onChange = _ref.onChange,
      validations = _ref.validations,
      value = _ref.value;

  var _getFormMethods = (0, _getFormMethods2["default"])({
    mode: 'onChange'
  }),
      errors = _getFormMethods.errors,
      register = _getFormMethods.register;

  var fieldErrors = error || errors[id];
  var required = (0, _get["default"])(validations, 'required');

  var _useState = (0, _react.useState)(checked),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];

  var handleCheckboxChange = function handleCheckboxChange(event) {
    setIsChecked(event.target.checked);

    if (onChange) {
      onChange(event);
    }
  };

  (0, _react.useEffect)(function () {
    setIsChecked(checked);
  }, [checked, setIsChecked]);
  return (
    /*#__PURE__*/
    // unicode value for &nbsp: \u00a0
    _react["default"].createElement(_Checkbox.StyledCheckbox, {
      className: className,
      disabled: disabled
    }, /*#__PURE__*/_react["default"].createElement("input", {
      checked: isChecked,
      disabled: disabled,
      id: id,
      name: id,
      onChange: handleCheckboxChange,
      ref: register(validations),
      type: "checkbox",
      value: value
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "checkmark"
    }), /*#__PURE__*/_react["default"].createElement(_Checkbox.StyledCheckboxLabel, {
      htmlFor: id
    }, label || "\xA0", required && /*#__PURE__*/_react["default"].createElement(_Checkbox.StyledCheckboxRequired, {
      disabled: disabled
    }, "*")), fieldErrors && /*#__PURE__*/_react["default"].createElement(_Checkbox.StyledCheckboxError, null, fieldErrors.message))
  );
};

Checkbox.defaultProps = {
  checked: false,
  className: null,
  disabled: false,
  error: undefined,
  onChange: null,
  validations: null,
  value: undefined,
  label: undefined
};
Checkbox.propTypes = {
  /** Disabled state */
  disabled: _propTypes.bool,

  /** Checked state */
  checked: _propTypes.bool,

  /** Custom class to be added to the container */
  className: _propTypes.string,

  /** For passing external errors to the component */
  error: (0, _propTypes.shape)({
    message: _propTypes.string
  }),

  /** Checkbox unique identifier */
  id: _propTypes.string.isRequired,

  /** The button label */
  label: _propTypes.string,

  /** Function to trigger when checkbox state is updated */
  onChange: _propTypes.func,

  /** Validations to be provided for the component. */
  validations: (0, _propTypes.shape)({
    required: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string]),
    validate: (0, _propTypes.shape)({})
  }),

  /** The input value */
  value: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string, _propTypes.number])
};
Checkbox.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Checkbox",
  "props": {
    "checked": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Checked state",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Custom class to be added to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Disabled state",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "error": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "For passing external errors to the component",
      "type": {
        "name": "shape",
        "value": {
          "message": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Function to trigger when checkbox state is updated",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "validations": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Validations to be provided for the component.",
      "type": {
        "name": "shape",
        "value": {
          "required": {
            "name": "union",
            "value": [{
              "name": "bool"
            }, {
              "name": "string"
            }],
            "required": false
          },
          "validate": {
            "name": "shape",
            "value": {},
            "required": false
          }
        }
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "The input value",
      "type": {
        "name": "union",
        "value": [{
          "name": "bool"
        }, {
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false
    },
    "label": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "The button label",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "id": {
      "description": "Checkbox unique identifier",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = Checkbox;
exports["default"] = _default;